import {BIOMATCH_FAILURE_REASONS} from '../../../hooks/iv/biomatchFailure';
import {isServiceFailure} from '../../../hooks/iv/serviceFailure';
import type {IVFailureReason} from '../../../hooks/iv/documentSelfieDetection/types';

type IVErrorSubject = 'face' | 'read' | 'match' | 'check' | 'document' | 'selfie';

const FACE_REASONS: IVFailureReason[] = [
  BIOMATCH_FAILURE_REASONS.documentFaceNotDetected,
  BIOMATCH_FAILURE_REASONS.selfieFaceNotDetected,
  BIOMATCH_FAILURE_REASONS.multipleFaces,
];

const BIOMATCH_REASONS = Object.values(BIOMATCH_FAILURE_REASONS) as IVFailureReason[];

function getIVErrorSubject(isSelfie: boolean, reason?: IVFailureReason): IVErrorSubject {
  if (isServiceFailure(reason)) return 'check';
  if (reason && FACE_REASONS.includes(reason)) return 'face';
  if (reason === BIOMATCH_FAILURE_REASONS.facesDoNotMatch) return 'match';
  if (reason && !BIOMATCH_REASONS.includes(reason)) return 'read';
  return isSelfie ? 'selfie' : 'document';
}

export function getIVErrorTitleKey(
  isSelfie: boolean,
  reason: IVFailureReason | undefined,
  isRepeated: boolean,
) {
  const subject = getIVErrorSubject(isSelfie, reason);
  return `error_title_${subject}${isRepeated ? '_again' : ''}`;
}
